var _clipPath, _rect, _g, _rect2, _rect3, _text, _g2, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f0f9ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e0f2fe",
      stopOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-clip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 250,
    r: 200
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "url(#bg-grad)",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 50) scale(0.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    fill: "#ef4444",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 20,
    height: 60,
    rx: 4,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#ef4444"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 300,
    width: 500,
    height: 150,
    fill: "#ffffff",
    stroke: "#cbd5e1",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 380,
    width: 100,
    height: 70,
    fill: "#3b82f6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 340,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 24,
    fill: "#1e293b"
  }, "HOSPITAL MANAGEMENT")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#94a3b8",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 320,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 320,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 320,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 320,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 320,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 320,
    width: 40,
    height: 40,
    rx: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 60,
    fill: "#3b82f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 30 L60 30 L60 70 L40 70 Z M35 35 L65 35 M35 45 L65 45",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 10,
    fill: "#2563eb",
    opacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 450 Q100 450 120 400 L140 480 L160 420 L180 460 Q200 450 750 450",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 3,
    strokeDasharray: 1000,
    strokeDashoffset: 0,
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalProject);
export default __webpack_public_path__ + "static/media/hospital-project.4fe7e325d85eb5b460a93253abd248ad.svg";
export { ForwardRef as ReactComponent };